import { SelectButton } from "primereact/selectbutton";

import { ListToolbar, TableActionsMenu } from "@/ds";
import { FiltersPopover } from "@/shared/components/filters-popover";
import styles from "./lista-toolbar.module.scss";
import type { ListaToolbarViewMode, ListaToolbarViewModel } from "./types-lista-toolbar";

/** Contexto que o Prime entrega ao `pt.button` de cada opção do seletor de visão. */
interface ViewItemContext {
  context: { option: { mode: ListaToolbarViewMode } };
}

export function ListaToolbarView({
  isMobile,
  view,
  showViewSwitch,
  changeView,
  searchWidth,
  searchSize,
  inlineActions,
  showSearch,
  search,
  changeSearch,
  searchPlaceholder,
  quickFilters,
  actionsEnd,
  filterDefinitions,
  filterValue,
  onFilterChange,
  savedFilters,
  onSaveFilter,
  onDeleteSavedFilter,
  onApplySavedFilter,
  onExport,
  onOpenSettings,
  controlSize,
  showFilters,
  viewOptions,
  testIds,
  viewOptionTestId,
}: ListaToolbarViewModel) {
  const rootClassName = [
    styles.toolbar,
    isMobile ? styles.mobile : "",
    isMobile && inlineActions ? styles.mobileInline : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ListToolbar.Root
      testId={testIds.root}
      framed={false}
      aria-label="Barra da listagem"
      className={rootClassName}
    >
      {showSearch ? (
        <ListToolbar.Search
          value={search}
          onChange={changeSearch}
          placeholder={searchPlaceholder}
          width={searchWidth}
          size={searchSize}
          clearable
          testId={testIds.search}
        />
      ) : null}

      <ListToolbar.Filters className={styles.filters}>
        {quickFilters}

        {showFilters ? (
          <FiltersPopover
            definitions={filterDefinitions}
            value={filterValue}
            onChange={onFilterChange}
            savedFilters={savedFilters}
            onSaveFilter={onSaveFilter}
            onDeleteSavedFilter={onDeleteSavedFilter}
            onApplySavedFilter={onApplySavedFilter}
            isMobile={isMobile}
            testId={testIds.filters}
          />
        ) : null}
      </ListToolbar.Filters>

      <ListToolbar.Actions className={styles.actions}>
        {showViewSwitch ? (
          <SelectButton
            className={styles.viewSwitch}
            value={view}
            options={[...viewOptions]}
            optionLabel="label"
            optionValue="mode"
            allowEmpty={false}
            onChange={(event) => changeView(event.value)}
            aria-label="Visualização"
            pt={{
              // O Prime passa `context.option` ao `pt.button` de cada item, mas a tipagem não o declara.
              button: (options) => ({
                className: styles.viewOption,
                "data-testid": viewOptionTestId(
                  (options as unknown as ViewItemContext).context.option.mode,
                ),
              }),
              label: { className: styles.viewOptionContent },
            }}
          />
        ) : null}

        {actionsEnd}

        <TableActionsMenu.Root testId={testIds.menu}>
          <TableActionsMenu.Trigger size={controlSize} />
          <TableActionsMenu.ExportItem onClick={onExport} />
          <TableActionsMenu.SettingsItem onClick={onOpenSettings} />
        </TableActionsMenu.Root>
      </ListToolbar.Actions>
    </ListToolbar.Root>
  );
}
